import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import { AuthProvider, useAuth } from './auth/AuthContext';
import { AuthScreen } from './auth/AuthScreen';
import { AddSheetProvider } from './components/AddSheet';
import { AppShell } from './components/AppShell';
import { Spinner } from './components/ui';
import { HomePage } from './pages/Home';
import { MesePage } from './pages/Mese';
import { BudgetPage } from './pages/Budget';
import { AltroPage } from './pages/Altro';

// Statistiche e Liquidita' sono le uniche schermate che caricano la libreria
// dei grafici: stanno fuori dal bundle iniziale.
const StatistichePage = lazy(() =>
  import('./pages/Statistiche').then((m) => ({ default: m.StatistichePage })),
);

const LiquiditaPage = lazy(() =>
  import('./pages/Liquidita').then((m) => ({ default: m.LiquiditaPage })),
);

export function App() {
  return (
    <AuthProvider>
      <Gate />
    </AuthProvider>
  );
}

function Gate() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-dvh items-center justify-center">
        <Spinner />
      </div>
    );
  }
  if (!user) return <AuthScreen />;

  return (
    <AddSheetProvider>
      <Routes>
        <Route element={<AppShell />}>
          <Route index element={<HomePage />} />
          <Route path="/mese" element={<MesePage />} />
          <Route
            path="/statistiche"
            element={
              <Suspense fallback={<Spinner />}>
                <StatistichePage />
              </Suspense>
            }
          />
          <Route path="/budget" element={<BudgetPage />} />
          <Route
            path="/liquidita"
            element={
              <Suspense fallback={<Spinner />}>
                <LiquiditaPage />
              </Suspense>
            }
          />
          <Route path="/altro" element={<AltroPage />} />
        </Route>
      </Routes>
    </AddSheetProvider>
  );
}
